import { newReleases } from '@/mocks/animeData';
import ComicCard from './ComicCard';

export default function NewReleases() {
  return (
    <section id="new" className="scroll-mt-20 bg-background-100 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              新作首发
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              开篇节奏紧凑、设定够新鲜的连载，抢先一步开追
            </p>
          </div>
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
            <i className="ri-sparkling-2-fill"></i>
            本周新上架
          </span>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4">
          {newReleases.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}